import React from 'react'
import PropTypes from 'prop-types'

import Dropdown from '../../../../shared/components/dropdown'
import { filterSortByOptions } from '../../../../../common/utils/item'
import siteDefaultConfigs from '../../../../../config/sites/defaults'
import { getConfigBySite } from '../../../../../config/sites'
import SortIcon from '../../../../shared/components/icons/sort'

const searchQueryConfigs = siteDefaultConfigs['search_query']
const defaultSortByOptions = searchQueryConfigs['default_sort_by_options']

/**
 * A sort by menu which has lots of business logic
 */
class SortByDropdown extends React.Component {
  static propTypes = {
    locationParams: PropTypes.object.isRequired,
    currentSite: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,
    makeSearchLink: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.onSortBySelectionChange = this.onSortBySelectionChange.bind(this)
  }

  getSelectSortByValue(parsedLocation) {
    let sortOrder

    if (parsedLocation.sort_by) {
      if (parsedLocation.sort_by === 'price' && parsedLocation.sort_direction) {
        sortOrder = 'price-' + parsedLocation.sort_direction
      } else {
        sortOrder = parsedLocation.sort_by
      }
    } else {
      if (parsedLocation.term) {
        sortOrder = 'relevance'
      } else {
        sortOrder = getConfigBySite(
          this.props.currentSite,
          'search_query.default_sort_by'
        )
      }
    }

    return sortOrder
  }

  onSortBySelectionChange(event) {
    const { push, locationParams, makeSearchLink } = this.props

    let sort = event.target.value
    let newQuery = Object.assign({}, locationParams, {
      sort
    })
    delete newQuery.sort_by
    delete newQuery.sort_direction

    push(makeSearchLink(newQuery))
  }

  render() {
    const { locationParams, currentSite } = this.props

    const sortByOptions = filterSortByOptions(
      currentSite,
      locationParams,
      defaultSortByOptions
    )
    const selectedSortByValue = this.getSelectSortByValue(locationParams)

    // Append "Sort by:" to selected label
    const sortByOptionsWithLabel = sortByOptions.map(option => {
      if (option.value === selectedSortByValue) {
        return {
          ...option,
          label: `Sort by: ${option.label}`
        }
      } else {
        return option
      }
    })

    return (
      <div className="inline-select-wrapper">
        <div className="search-facet-header--horizontal">
          <h2>
            <SortIcon title="Sort by" />
          </h2>
        </div>
        <div className="-border-top-none -border-radius-none inline-select">
          <label htmlFor="sortby" className="fds-u-is-visually-hidden">
            Sort by:{' '}
          </label>
          <Dropdown
            name="sortby"
            id="sortby"
            options={sortByOptionsWithLabel}
            onChange={this.onSortBySelectionChange}
            value={selectedSortByValue}
          />
        </div>
      </div>
    )
  }
}

export default SortByDropdown
